module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/nickAndNatalieInvite@2x-fb45a261a7604475b9cf856ca6864d52.jpg";